module.exports = __webpack_public_path__ + "static/zapier-trigger-frankenstein-9385c66593cd1cec4be1ef334421a197.svg";